export default __webpack_public_path__ + "static/Klasse_Steira_SB-c9825883786e42ba161650b70cfdaddd.jpg";